import type { IHttpResponse } from '@/interfaces/http.interface';
import type { IUser, IUserDataPayload, IUserResponseData } from '@/interfaces/user.interface';
import api from '@/utils/axiosInstance';

export const getUserProfile = async (): Promise<IHttpResponse<IUserResponseData>> => {
  const result = await api.get('/user/profile');
  return result.data;
};

export const updateProfile = async (userDataPayload?: IUserDataPayload): Promise<IHttpResponse<IUser>> => {
  const result = await api.patch('/user/profile', userDataPayload);
  return result.data;
};
